import { createReducer } from 'redux-act';
import {
  setCollectionsOverviewPage,
  setCollectionsOverviewSearch,
  setCollectionsOverviewSort,
  resetCollectionsOverviewUi
} from './../../actions/collectionsOverviewUi';

export interface ICollectionsOverviewUiState {
  currentPage: number;
  search: string;
  sortBy: string;
  sortOrder: 'asc' | 'desc';
}

const DEFAULT_SORT_BY = 'updated_at';
const DEFAULT_SORT_ORDER: 'asc' | 'desc' = 'desc';

const readStoredSort = (): { sortBy: string; sortOrder: 'asc' | 'desc' } => {
  try {
    const raw = localStorage.getItem('collectionsOverviewSorting');

    if (!raw) {
      return { sortBy: DEFAULT_SORT_BY, sortOrder: DEFAULT_SORT_ORDER };
    }
    const parsed = JSON.parse(raw);
    const dir = parsed?.direction;
    const sortOrder: 'asc' | 'desc' = dir === 'asc' || dir === 'desc' ? dir : DEFAULT_SORT_ORDER;

    return { sortBy: parsed?.column || DEFAULT_SORT_BY, sortOrder };
  } catch (e) {
    return { sortBy: DEFAULT_SORT_BY, sortOrder: DEFAULT_SORT_ORDER };
  }
};

const initState: ICollectionsOverviewUiState = {
  currentPage: 0,
  search: '',
  ...readStoredSort()
};

export const collectionsOverviewUi = createReducer({}, initState);

collectionsOverviewUi.on(setCollectionsOverviewPage, (state, currentPage) => ({
  ...state,
  currentPage
}));

collectionsOverviewUi.on(setCollectionsOverviewSearch, (state, search) => ({
  ...state,
  search
}));

collectionsOverviewUi.on(setCollectionsOverviewSort, (state, { sortBy, sortOrder }) => ({
  ...state,
  sortBy,
  sortOrder
}));

collectionsOverviewUi.on(resetCollectionsOverviewUi, () => ({
  currentPage: 0,
  search: '',
  ...readStoredSort()
}));
